export default __webpack_public_path__ + "static/media/Linked_White.80948dd9.svg";